import React from "react";
import { Row, Col, Button, Input, Drawer, Form } from "antd";
import Close from "../../../../assets/images/close-x.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import data from "../../../../constants/retailPos.json";

const GiftCardRedeemDrawer = ({
  giftCardFlag,
  setGiftCardFlag,
  giftCardForm,
  redeemGiftCard,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  setGiftCardBalance,
  giftCardBalance,
  setInputFocused,
  inputFocused,
  handleGiftCard,
  handleAddGiftCardAmount,
  cart,
  amount,
  isSubmitting,
  redeemNumberRef,
  width,
}) => {
  return (
    <Drawer
      closable={false}
      placement="bottom"
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "2vh",
            fontSize: "1vw",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              marginTop: "3vh",
              fontWeight: "500",
              color: "#0F0718",
              flex: 1,
              textAlign: "center",
            }}
          >
            Redeem {selectedPaymentMethod.name}
          </p>
          <img
            src={Close}
            onClick={() => {
              setSelectedPaymentMethod({});
              giftCardForm.resetFields();
              setGiftCardFlag(false);
              setGiftCardBalance(0.0);
            }}
            // style={{ marginLeft: "auto", paddingBottom: "4vh", cursor: "pointer" }}
            style={{
              marginLeft: "auto",
              paddingBottom: "4vh",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      headerStyle={{ background: "#f3f4f9", borderBottom: "none" }}
      bodyStyle={{ backgroundColor: "#f3f4f9" }}
      open={giftCardFlag}
      className="filter"
      styles={{ body: { paddingBottom: 0, paddingTop: 0 } }}
      onClose={() => {
        setSelectedPaymentMethod({});
        setGiftCardFlag(false);
        giftCardForm.resetFields();
        setGiftCardBalance(0.0);
      }}
      //  id="sm-drawer-close"
      height="87vh"
    >
      <Form layout="vertical" onFinish={redeemGiftCard} form={giftCardForm} style={{ fontSize: "1vw" }}>
        <Row>
          <Col span={11} offset={1}>
            <Row style={{ paddingRight: "1vw" }}>
              <Col span={20} pull={2} push={2}>
                <Form.Item
                  style={{ marginBottom: "10px", fontSize: "1vw" }}
                  name="number"
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                        }}
                      >
                        {selectedPaymentMethod.name} Number
                      </span>
                    </div>
                  }
                >
                  <Input
                    ref={redeemNumberRef}
                    id="redeemNumber"
                    placeholder={`Enter Number`}
                    onFocus={() => {
                      setInputFocused("redeemNumber");
                    }}
                    // prefix={<UserOutlined style={{color:"#929098"}}/>}
                    size="large"
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear={false}
                    style={{
                      ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                      padding: "2vh 1vw",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={20} pull={2} push={2} style={{ padding: "" }}>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  name="pin"
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.25em",
                          fontWeight: "500",
                        }}
                      >
                        PIN
                      </span>
                    </div>
                  }
                >
                  <Input
                    id="pin"
                    onFocus={() => {
                      setInputFocused("pin");
                    }}
                    placeholder={`  Enter Pin`}
                    size="large"
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear={false}
                    style={{
                      ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                      padding: "2vh 1vw",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={20} pull={2} push={2} style={{ padding: "1% 0", fontSize: "1vw" }}>
                <Button
                  style={{
                    backgroundColor: "#046307C2",
                    color: "#fff",
                    width: "40%",
                    fontSize: "1.25em",
                    textAlign: "center",
                    fontWeight: "500",
                    borderRadius: "5px",
                    height: "8vh",
                  }}
                  onClick={handleGiftCard}
                >
                  Check Balance
                </Button>
              </Col>
              <Col span={8} push={2} style={{ padding: "" }}>
                <Form.Item
                  style={{ marginBottom: "", fontSize: "1vw" }}
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.15em",
                          fontWeight: 500,
                        }}
                      >
                        {selectedPaymentMethod.name} Balance
                      </span>
                    </div>
                  }
                >
                  <span
                    style={{
                      fontSize: "2.5em",
                      fontWeight: 500,
                      lineHeight: "2rem",
                      color: "#0F0718",
                    }}
                  >
                    {parseFloat(giftCardBalance ?? 0).toFixed(2)}
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} offset={4} push={2} style={{ padding: "" }}>
                <Form.Item
                  style={{ marginBottom: "", fontSize: "1vw" }}
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.15em",
                          fontWeight: 500,
                        }}
                      >
                        Bill Amount
                      </span>
                    </div>
                  }
                >
                  <span
                    style={{
                      fontSize: "2.5em",
                      fontWeight: 500,
                      lineHeight: "2rem",
                      color: "#0F0718",
                    }}
                  >
                    {!isNaN(cart?.total) ? parseFloat(cart?.total).toFixed(2) : cart?.total.toFixed(2)}
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} push={2} style={{ padding: "" }}>
                <Form.Item
                  style={{ marginBottom: "", fontSize: "1vw" }}
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.15em",
                          fontWeight: 500,
                        }}
                      >
                        Redeem Amount
                      </span>
                    </div>
                  }
                >
                  <span
                    style={{
                      fontSize: "2.5em",
                      fontWeight: 500,
                      lineHeight: "2rem",
                      color: "#0F0718",
                    }}
                  >
                    {cart.payments?.find((item) => item.finPaymentmethodId === selectedPaymentMethod?.finPaymentmethodId)?.amount ?? "0.00"}
                  </span>
                </Form.Item>
              </Col>
              <Col span={8} offset={4} push={2} style={{ padding: "" }}>
                <Form.Item
                  style={{ marginBottom: "", fontSize: "1vw" }}
                  label={
                    <div style={{ fontSize: "1vw" }}>
                      <span
                        style={{
                          color: "#0F0718",
                          fontSize: "1.15em",
                          fontWeight: 500,
                        }}
                      >
                        Remaining Due
                      </span>
                    </div>
                  }
                >
                  <span
                    style={{
                      fontSize: "2.5em",
                      fontWeight: 500,
                      lineHeight: "2rem",
                      color: "#0F0718",
                    }}
                  >
                    {amount}
                  </span>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={11} offset={1} style={{ padding: "" }}>
            <Row style={{ padding: "0% 1% 0 3.5%" }} gutter={[8, 6]}>
              <Row style={{ padding: "0 8%", width: "100%" }}>
                <Col span={24} style={{ padding: "" }}>
                  <Form.Item
                    style={{ marginBottom: "10px", fontSize: "1vw" }}
                    name="amount"
                    label={
                      <div style={{ fontSize: "1vw" }}>
                        <span
                          style={{
                            color: "#0F0718",
                            fontSize: "1.25em",
                            fontWeight: "500",
                          }}
                        >
                          Redeem Amount
                        </span>
                      </div>
                    }
                  >
                    <Input
                      id="amountNumber"
                      onFocus={() => {
                        setInputFocused("amount");
                      }}
                      // placeholder={`Type to add a note`}
                      size="large"
                      onPressEnter={(e) => e.preventDefault()}
                      allowClear={false}
                      style={{
                        ...data.posScreenStyles.orderHistoryModal.cashManagmentSearchInput,
                        padding: "2.5vh 1vw",
                        fontSize: "1em",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ padding: "0 8%" }} gutter={[8, 6]}>
                <Col span={6}>
                  <button
                    id="sm-amount-button1"
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleAddGiftCardAmount("1");
                      e.preventDefault();
                    }}
                  >
                    1
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button2"
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleAddGiftCardAmount("2");
                      e.preventDefault();
                    }}
                  >
                    2
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button3"
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleAddGiftCardAmount("3");
                      e.preventDefault();
                    }}
                  >
                    3
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    className="amt-dial-btn-gift"
                    id="sm-amount-buttonRemove"
                    onClick={(e) => {
                      handleAddGiftCardAmount("x");
                      e.preventDefault();
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                  >
                    <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button4"
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleAddGiftCardAmount("4");
                      e.preventDefault();
                    }}
                  >
                    4
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button5"
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleAddGiftCardAmount("5");
                      e.preventDefault();
                    }}
                  >
                    5
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-button6"
                    className="amt-dial-btn-gift"
                    onClick={(e) => {
                      handleAddGiftCardAmount("6");
                      e.preventDefault();
                    }}
                  >
                    6
                  </button>
                </Col>
                <Col span={6}>
                  <button
                    onClick={(e) => {
                      handleAddGiftCardAmount("clear");
                      e.preventDefault();
                    }}
                    id="sm-amount-addQuantity"
                    className="amt-dial-btn-gift"
                  >
                    Clear
                  </button>
                </Col>
                <Col span={18}>
                  <Row gutter={[8, 6]}>
                    <Col span={8}>
                      <button
                        id="sm-amount-button7"
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleAddGiftCardAmount("7");
                          e.preventDefault();
                        }}
                      >
                        7
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button8"
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleAddGiftCardAmount("8");
                          e.preventDefault();
                        }}
                      >
                        8
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button0"
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleAddGiftCardAmount("9");
                          e.preventDefault();
                        }}
                      >
                        9
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button0"
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleAddGiftCardAmount("0");
                          e.preventDefault();
                        }}
                      >
                        0
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button00"
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleAddGiftCardAmount(".");
                          e.preventDefault();
                        }}
                      >
                        .
                      </button>
                    </Col>
                    <Col span={8}>
                      <button
                        id="sm-amount-button."
                        className="amt-dial-btn-gift"
                        onClick={(e) => {
                          handleAddGiftCardAmount("00");
                          e.preventDefault();
                        }}
                      >
                        00
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col span={6}>
                  <button
                    id="sm-amount-buttonEnter"
                    className="amt-dial-btn-gift2"
                    onClick={(e) => {
                      e.preventDefault();
                      giftCardForm.submit();
                    }}
                  >
                    Enter
                  </button>
                </Col>
                <Col span={24} style={{ padding: "3% 0", marginTop: "1%", fontSize: "1vw" }}>
                  <Button
                    disabled={!giftCardForm.getFieldValue("number") || isSubmitting}
                    htmlType="submit"
                    style={{
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      width: "100%",
                      fontSize: "1.5em",
                      textAlign: "center",
                      fontWeight: "500",
                      borderRadius: "7px",
                      height: "8vh",
                    }}
                  >
                    Redeem
                  </Button>
                </Col>
              </Row>
            </Row>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default GiftCardRedeemDrawer;
